import * as React from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import SearchIcon from '@mui/icons-material/Search';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded';
import SaveIcon from '@mui/icons-material/Save';
import { useAppSelector } from 'commons/store/hooks';
import { useTranslation } from "react-i18next";
import { DISPLAY_NAV_SECTION, RESEARCH } from "commons/constants/env";
import { selectCurrentSection } from "../../../redux/ecrfSlice";
import { ROUTES_ECRF } from "commons/constants/paths";
import { useNavigate, useParams } from "react-router-dom";
import {useFormikContext} from "formik";

const StyledFab = styled(Fab)({
  position: 'absolute',
  zIndex: 1,
  top: -30,
  left: 0,
  right: 0,
  margin: '0 auto',
  width: '120px',
});

interface Props {}

export const BottomPanel: React.FC<Props> = () => {
  const { dirty, isSubmitting } = useFormikContext();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  /** This is current selected section data */
  const currentSection = useAppSelector(selectCurrentSection);

  const disableNextPrevButton = (): boolean => RESEARCH === 'IMPROVE';
  const disableNavSection = (): boolean => (DISPLAY_NAV_SECTION !== 'FALSE');

  return (
    <AppBar color="default" position="sticky" sx={{ bottom: 0, top: 'auto' }}>
      <Toolbar variant="dense">
        {disableNavSection() && (
          <Tooltip title={t('go-to-the-previous-section')} arrow>
            <span>
              <Button
                color='primary'
                size='small'
                aria-label="open drawer"
                disabled={currentSection?.prev === false || disableNextPrevButton()}
                onClick={() => id && navigate(ROUTES_ECRF.DETAILS_EXTENDED(id, currentSection?.prev), { replace: true })}
              >
                <NavigateBeforeRoundedIcon />
                {t('previous')}
              </Button>
            </span>
          </Tooltip>
        )}
        <StyledFab
          type="submit"
          color="secondary"
          variant="extended"
          aria-label="save"
          title={t('save-all-completed-fields-desc')}
          disabled={!dirty || isSubmitting}
        >
          <SaveIcon sx={{ mr: 1 }} />
          {isSubmitting ? t('saving') : t('save')}
        </StyledFab>
        <Box sx={{ flexGrow: 1 }} />
        {/*<IconButton color="primary">*/}
        {/*  <SearchIcon />*/}
        {/*</IconButton>*/}
        <Tooltip title={t('go-to-the-next-section')} arrow>
          <span>
            <Button
              color="primary"
              size='small'
              disabled={currentSection?.next === false || disableNextPrevButton()}
              onClick={() => id && navigate(ROUTES_ECRF.DETAILS_EXTENDED(id, currentSection?.next), { replace: true })}
            >
              {t('next')}
              <NavigateNextRoundedIcon />
            </Button>
          </span>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
};
